import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface CivilFormData {
  fullName: string
  age?: number
  phone: string
  position: string
  hobbies?: string
}

export interface MilitaryFormData {
  position: string
  fullName: string
  age?: number
  militaryRank: string
  bzpvCompleted: 'yes' | 'no' | ''
  szcStatus: 'yes' | 'no' | ''
  phone: string
}

interface ApplicationStore {
  civilForm: Partial<CivilFormData>
  militaryForm: Partial<MilitaryFormData>
  setCivilForm: (data: Partial<CivilFormData>) => void
  setMilitaryForm: (data: Partial<MilitaryFormData>) => void
  resetCivilForm: () => void
  resetMilitaryForm: () => void
}

const initialCivilForm: Partial<CivilFormData> = {}
const initialMilitaryForm: Partial<MilitaryFormData> = {}

export const useApplicationStore = create<ApplicationStore>()(
  persist(
    (set) => ({
      civilForm: initialCivilForm,
      militaryForm: initialMilitaryForm,
      setCivilForm: (data) => set((state) => ({ civilForm: { ...state.civilForm, ...data } })),
      setMilitaryForm: (data) =>
        set((state) => ({ militaryForm: { ...state.militaryForm, ...data } })),
      resetCivilForm: () => set({ civilForm: initialCivilForm }),
      resetMilitaryForm: () => set({ militaryForm: initialMilitaryForm }),
    }),
    {
      name: 'application-storage',
    },
  ),
)
